<div class="container-fluid mb-3">
  <div class="row no-gutters">
    <div class="col-6">
      <h5 id="Section1Title">
        {{ sectionName }}
      </h5>
    </div>
    <div class="col-6 right-align">
      <span *ngIf="isVacuumSection && !disabled" class="btn float-right m-0">
        <button
          mat-flat-button
          color="warn"
          (click)="saveEpicsValues()"
          [disabled]="disableButtons()"
        >
          <mat-icon>update</mat-icon>&nbsp;Refresh Vacuum Values
        </button>
      </span>
      <span
        *ngIf="
          section === 5 &&
          this.ke?.status === formStatusEnum.KeyEnable &&
          this.hasRoles([roleEnum.FO])
        "
        class="btn float-right m-0"
      >
        <button
          mat-flat-button
          color="primary"
          (click)="resetStatusShieldings()"
        >
          <mat-icon color="warn">settings_backup_restore</mat-icon>
          {{ resetSection4() }}
        </button>
      </span>
      <span
        *ngIf="isShieldingsSection && !disabled"
        class="btn float-right m-0"
      >
        <button
          mat-flat-button
          color="primary"
          (click)="resetStatusToActive()"
          [disabled]="disableButtons()"
        >
          <mat-icon>settings_backup_restore</mat-icon>Revert to Previous Status
        </button>
      </span>
      <span *ngIf="ologButton" class="btn float-right m-0">
        <button
          mat-stroked-button
          color="primary"
          [disabled]="ologPermission()"
          (click)="editOlog()"
        >
          Edit Olog Notification&nbsp;<mat-icon>backup</mat-icon>
        </button>
      </span>
    </div>
    <div *ngIf="isKeStatus" class="ke-reminder">
      Reminder: Only the FO who filled out Section 4 may sign in Section 5
    </div>
  </div>

  <div *ngFor="let s of signatures">
    <div class="row no-gutters" *ngIf="s.required">
      <div class="col-12 p-1">
        <master-control
          [type]="s.type"
          [taskId]="s.id"
          [visible]="s.required"
          [enabled]="s.enabled"
          [disabled]="s.disabled"
          [radioDisabled]="s.radioDisabled"
          [color]="'primary'"
          [number]="s.number"
          [header]="s.number == null ? s.name : s.number.toString()"
          [question]="s.question"
          [label]="s.name"
          [text]="s.question"
          [resourceID]="resourceID"
          [radioQuestion]="s.question2"
          [radioOptions]="s.options"
          [radioSelection]="s.value2"
          [condition]="s.condition"
          [checkbox_checked]="s.approved"
          [approved]="s.approved"
          [suggested]="s.suggested ?? false"
          [suggestionReason]="s.suggestionReason"
          [approvedBy]="s.approvedBy"
          [approvedOn]="s.approvedOn"
          [roleIds]="s.roles"
          [roleCodes]="s.roleCodes"
          [tooltips]="s.tooltips"
          [textBefore]="
            s.type == 6 || s.type == 8 || s.type == 9 || s.type == 24
              ? s.question2
              : s.question
          "
          [textAfter]="
            s.type == 6 || s.type == 8 || s.type == 9 || s.type == 24
              ? s.question
              : s.question2
          "
          [textValue]="s.textValue"
          [checkboxVisible]="s.visible"
          [disableEdit]="s.disableEdit"
          [warning]="s.warning"
          color="primary"
          [moreInfo]="restrictionTooltip(s.moreInfo)"
          [locationMoreInfo]="locationTooltip(s.locationMoreInfo)"
          [textAfter2]="s.question3"
          [scheduleTypeId]="s.scheduleTypeId"
          [scheduleResourceId]="s.scheduleResourceId"
          [dateValue1]="s.dateValue1"
          [dateValue2]="s.dateValue2"
          [dateValue3]="s.dateValue3"
          [scheduleName]="s.scheduleName"
          [locationName]="s.locationName"
          [configuration]="s.configuration"
          [showApprove]="s.approveAction"
          [showUnapprove]="s.unapproveAction"
          [showDisapprove]="s.disapproveAction"
          [userNames]="s.moreInfo ?? ''"
          style="width: 100%"
          [currentChecklist]="ke ?? undefined"
          (changed)="change($event, s.id, s.type, s.isVacuum)"
          (duplicate)="duplicated()"
          (close)="closed()"
          (checked)="
            checkOrChange(
              $event,
              s.taskId,
              s.approveActionId,
              s.unapproveActionId,
              s.condition,
              s.moreInfo || s.locationMoreInfo || '',
              s.configuration,
              s.isVacuum,
              s.type
            )
          "
          (approve)="approve(s.taskId, s.approveActionId)"
          (unapprove)="unapprove(s.taskId, s.unapproveActionId)"
          (save)="change($event, s.id, s.type, s.isVacuum)"
        >
        </master-control>
      </div>
    </div>
  </div>
  <div class="row no-gutters">
    <div class="col-3 offset-9">
      <span
        *ngIf="isVacuumSection && !disabled && abbreviated && !loading"
        class="btn float-right m-0"
      >
        <button
          mat-flat-button
          color="primary"
          (click)="skipStatusToShieldings()"
          [disabled]="disableButtons()"
        >
          <mat-icon color="warn">next_plan</mat-icon>&nbsp;Skip to Section 4
        </button>
      </span>
      <span
        *ngIf="
          isVacuumSection &&
          !disabled &&
          !abbreviated &&
          returnButton() &&
          !loading &&
          completeActive
        "
        class="btn float-right m-0"
      >
        <button
          mat-flat-button
          color="primary"
          (click)="skipStatusToShieldings()"
          [disabled]="disableButtons()"
        >
          <mat-icon color="warn">next_plan</mat-icon>&nbsp;Return to Section 4
        </button>
      </span>
    </div>
  </div>
</div>
